import React, { useReducer, useEffect, useContext } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import {
  createReducer,
  createInitialState,
} from "../../../reducers/module/createReducer";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormRichText from "../../UI/forms/CMSFormRichText";
import CMSFormImage from "../../UI/forms/CMSFormImage";
import {
  loadDataForCreateItemGeneral,
  onSubmitGeneral,
} from "../../../helpers/ModuleHelperFunctions";
import CMSFormColor from "../../UI/forms/CMSFormColor";
import CMSFormMultiSelect from "../../UI/forms/CMSFormMultiSelect";
import CMSFormDate from "../../UI/forms/CMSFormDate";

const JobCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    createInitialState
  );
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();

  //  const loadDataForCreateItem = async () => {
  //     await loadDataForCreateItemGeneral(`${moduleConfig.url}/fetch-data-for-create-item`,createDispatch)
  //   };

  useEffect(() => {
    //loadDataForCreateItem();
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.create,
    ]);
  }, []);

  return (
    <DashboardLayout>
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {/* {console.log(createState.data)} */}
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        title: "",
                        shortDescription: "",
                        description: "",
                        joiningTime: "",
                        employmentType: "Full Time",
                        postedDate: "",
                        salary: "",
                        status: "0",
                      }}
                      validationSchema={yup.object({
                        title: yup.string().required("Title is required."),
                        shortDescription: yup
                          .string()
                          .required("Short description is required."),
                        description: yup
                          .string()
                          .required("Description is required."),
                        joiningTime: yup.string().nullable(),
                        employmentType: yup
                          .string()
                          .required("Employment type is required."),
                        postedDate: yup.string().nullable(),
                        salary: yup.string().nullable(),
                        status: yup.string().required("Status is required."),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        const formData = new FormData();
                        for (let name in values) {
                          if (Array.isArray(values[name])) {
                            formData.append(name, JSON.stringify(values[name]));
                          } else {
                            formData.append(name, values[name]);
                          }
                        }
                        await onSubmitGeneral(
                          formData,
                          moduleConfig.url,
                          moduleConfig.url,
                          createDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          {/* {console.log(form.errors)} */}
                          <CMSFormInput
                            name="title"
                            label="Title"
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="shortDescription"
                            label="Short Description"
                            required={true}
                            form={form}
                          />

                          <CMSFormRichText
                            name="description"
                            label="Description"
                            form={form}
                            required={true}
                          />

                          <CMSFormInput
                            name="joiningTime"
                            label="Joining Time"
                            required={false}
                            form={form}
                          />

                          <CMSFormSelect
                            name="employmentType"
                            label="Employment Type"
                            required={true}
                            form={form}
                            options={[
                              { label: "Full Time", value: "Full Time" },
                              { label: "Part Time", value: "Part Time" },
                            ]}
                          />

                          <CMSFormDate
                            name="postedDate"
                            label="Posted Date"
                            form={form}
                            required={false}
                          />

                          <CMSFormInput
                            name="salary"
                            label="Salary"
                            info=""
                            form={form}
                            required={false}
                          />
{/* 
                          <CMSFormImage
                            label="Image"
                            name="file"
                            info="Recommended dimensions 586*440"
                            form={form}
                            required={false}
                          /> */}

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            required={true}
                            form={form}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />

                          <button
                            type="submit"
                            onClick={() => form.handleSubmit}
                            className="btn btn-primary"
                          >
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default JobCreate;
